import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalHeader: {
    id: 'SHqNRV',
    defaultMessage: 'Insufficient Stock',
    description: 'Header for the stock errors modal',
  },
  modalDescription: {
    id: 'yQ0C+z',
    defaultMessage: 'The following products do not have enough available stock to complete this transfer:',
    description: 'Description text in the stock errors modal',
  },
  productColumnHeader: {
    id: '6A18Ts',
    defaultMessage: 'Product',
    description: 'Column header for product in stock errors table',
  },
  locationColumnHeader: {
    id: 'PiHWWN',
    defaultMessage: 'Location',
    description: 'Column header for location in stock errors table',
  },
  requestedColumnHeader: {
    id: 'guqo3E',
    defaultMessage: 'Requested',
    description: 'Column header for requested quantity in stock errors table',
  },
  availableColumnHeader: {
    id: '4GGEf0',
    defaultMessage: 'Available',
    description: 'Column header for available quantity in stock errors table',
  },
  missingColumnHeader: {
    id: 'oAgDxX',
    defaultMessage: 'Missing',
    description: 'Column header for missing quantity in stock errors table',
  },
  closeButton: {
    id: '4ppVRH',
    defaultMessage: 'Close',
    description: 'Close button text in stock errors modal',
  },
  lotIdColumnHeader: {
    id: 'MeWRLX',
    defaultMessage: 'Lot ID',
    description: 'Column header for lot ID in stock errors table',
  },
  expirationDateColumnHeader: {
    id: 'zszDnu',
    defaultMessage: 'Exp. Date',
    description: 'Column header for expiration date in stock errors table',
  },
  productSku: {
    id: 'Clp9M3',
    defaultMessage: 'SKU: {sku}',
    description: 'Product SKU label in stock errors table',
  },
  saveAsDraftButton: {
    id: 'nq6Uvt',
    defaultMessage: 'Save as Draft',
    description: 'Save as draft button in stock errors modal',
  },
  adjustStockButton: {
    id: 'lAyeb2',
    defaultMessage: 'Adjust Stock',
    description: 'Adjust stock button in stock errors modal',
  },
  adjustStockTooltip: {
    id: 'Ka3F4V',
    defaultMessage: 'Automatically reduces requested quantities to match available stock for affected items',
    description: 'Tooltip explaining what the adjust stock button does',
  },
  saveAsDraftTooltip: {
    id: '1/BSsa',
    defaultMessage: 'Saves the transfer order as a draft with the current quantities, skipping stock validation',
    description: 'Tooltip explaining what the save as draft button does',
  },
});
